// src/views/Settings/useSettingsGroups.js
//
// Los grupos del sub-nav de configuración, resueltos contra la sesión.
//
// Configuración muestra **lo que está scopeado a la sesión**: tú, y la cuenta en
// la que estás ahora. Ninguna de las dos se elige desde este menú — la cuenta se
// elige en el switcher. Las organizaciones no salen aquí: se entra a cualquiera
// de las que perteneces desde su lista, y esa forma de direccionar no encaja en
// un menú donde todo lo demás dice "ahora".
import { useTranslation } from 'react-i18next';
import { useOrganization } from '../../contexts/OrganizationContext';
import { settingsGroups } from '../../lib/settingsNav';

export default function useSettingsGroups() {
  const { t } = useTranslation();
  const { currentAccount, currentContext } = useOrganization();

  const isOrgContext = currentContext?.type === 'ORGANIZATION';

  return settingsGroups({
    accountId: currentAccount?.id ?? null,
    // El nombre de la cuenta activa. En contexto personal lleva tu propio
    // nombre, y "Cuenta personal" lo distingue de "Tú" mejor que repetirlo.
    accountName: isOrgContext
      ? currentAccount?.name || currentContext?.name
      : t('settingsNav.personalAccount', 'Personal account'),
    t,
  });
}
